var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketShoppingSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 296C192 309.3 181.3 320 168 320C154.7 320 144 309.3 144 296C144 282.7 154.7 272 168 272C181.3 272 192 282.7 192 296zM384 296C384 282.7 394.7 272 408 272C421.3 272 432 282.7 432 296C432 309.3 421.3 320 408 320C394.7 320 384 309.3 384 296zM243.1 2.71C254.8 8.825 259.4 23.32 253.3 35.08L171.7 192H404.3L322.7 35.08C316.6 23.32 321.2 8.825 332.9 2.71C344.7-3.405 359.2 1.171 365.3 12.93L458.4 192H552C565.3 192 576 202.7 576 216C576 229.3 565.3 240 552 240H532L476.1 463.5C468.1 492 443.4 512 414 512H161.1C132.6 512 107 492 99.88 463.5L44 240H24C10.75 240 0 229.3 0 216C0 202.7 10.75 192 24 192H117.6L210.7 12.93C216.8 1.171 231.3-3.405 243.1 2.71H243.1zM482.5 240H93.48L146.4 451.9C148.2 459 154.6 464 161.1 464H414C421.4 464 427.8 459 429.6 451.9L482.5 240z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketShoppingSimple);
export default __webpack_public_path__ + "static/media/basket-shopping-simple.460b81eb6daa4a25f7ebd94fe4f24b9f.svg";
export { ForwardRef as ReactComponent };